import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

// POST request with no data being passed
export const acceptTermsAndConditionsApi = createAsyncThunk(
  "auth/admin/terms-and-conditions",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.post(apiRoutes.channelAdminTermsAndConditions(_, 0));
      return response?.data;
    } catch (error) {
      return rejectWithValue({ 
        status: error?.response?.status, 
        message:
          error?.response?.status === 404
            ? "Page not found"
            : "An unexpected error occurred", 
        error: error?.message, 
      });
    }
  }
);

const initialState = { result: [], loading: false, error: null, message: "" };

const acceptTermsAndConditionsSlice = createSlice({
  name: "auth/admin/terms-and-conditions",
  initialState,
  reducers: {
    resetPage: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(acceptTermsAndConditionsApi.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.message = "";
      })
      .addCase(acceptTermsAndConditionsApi.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action?.payload?.result || [];
        state.message = action?.payload?.message || "";
        state.error = null;
      })
      .addCase(acceptTermsAndConditionsApi.rejected, (state, action) => {
        state.loading = false;
        state.result = [];
        state.error = action?.payload?.error || "Unknown error";
        state.message = action?.payload?.message || "An error occurred";
      });
  },
});

export const { resetPage } = acceptTermsAndConditionsSlice.actions;
export const acceptTermsAndConditionsReducer = acceptTermsAndConditionsSlice.reducer;
